import type { AlertDialog as BaseAlertDialog } from '@base-ui/react';

import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';

type Props = {
  handle: BaseAlertDialog.Handle<() => void>;
};

export const ConfirmExtraIntegrationDialog = ({ handle }: Props) => {
  const { t } = useTranslation(['settings']);
  const actionsRef = useRef<BaseAlertDialog.Root.Actions>(null);

  return (
    <AlertDialog.Root actionsRef={actionsRef} handle={handle}>
      {({ payload: action }) =>
        action && (
          <AlertDialog.Body status="warning">
            <AlertDialog.Title>{t('settings:integrations.peppol.confirmExtraIntegration.title')}</AlertDialog.Title>

            <AlertDialog.Description>{t('settings:integrations.peppol.confirmExtraIntegration.description')}</AlertDialog.Description>

            <AlertDialog.Actions>
              <AlertDialog.Close
                render={<Button emphasis="secondary">{t('settings:integrations.peppol.confirmExtraIntegration.cancel')}</Button>}
              />

              <Button
                onClick={() => {
                  handle.close();
                  // Skip the exit transition, so that no two backdrops overlap during the animation
                  // if the action opens another dialog (which is often the case).
                  actionsRef.current?.unmount();
                  action();
                }}
              >
                {t('settings:integrations.peppol.confirmExtraIntegration.confirm')}
              </Button>
            </AlertDialog.Actions>
          </AlertDialog.Body>
        )
      }
    </AlertDialog.Root>
  );
};
